import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({ eyebrow, title, description, actionLabel, actionTo }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {eyebrow && (
          <p className="eyebrow flex items-center gap-2 text-[11px] text-primary-500">
            <span className="h-px w-6 bg-primary-500" />
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2 font-heading text-2xl font-semibold tracking-wide text-foreground-950 md:text-3xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-500">{description}</p>}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300/70 px-4 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-500/70 hover:text-primary-500 md:text-sm"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}